import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Label,
  Button,
} from 'reactstrap';
import Shimmer from 'react-shimmer-effect';
import apiResponse from '../../../../services/apiResponse';
import IndexBloc from '../Index/Blocs/IndexBloc';

class IndexView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: null,
      positionOption: [],
      positionFilter: {
        filter_value: '',
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: 'job_id',
          order: 'asc',
        },
      },
    };
    this.indexBloc = new IndexBloc();
  }

  componentDidMount() {
    this.loadDetail();

    this.indexBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ detail: result.data.response });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.detailChannel?.unsubscribe();
  }

  loadDetail = async () => {
    await this.indexBloc.fetchDetail({ uuid: this.props.uuid });
  };

  renderDetailRow(label, value, type = "text") {
    return (
      <Row className="mb-3">
        <label
          htmlFor={label.toLowerCase().replace(' ', '_')}
          className="col-md-3 col-form-label"
        >
          {label}
        </label>
        <Col md="3">
          {this.state.detail ? (
            <>
                {type === "text" && <Label className="col-form-label">{value || '-'}</Label>}
                {type === "status" && <label className={`badge rounded-pill bg-soft-${value ? 'info' : 'warning'} font-size-12`}> {value ? 'Aktif' : 'Nonaktif'} </label>}
            </>
          ) : (
            <Shimmer>
              <div
                style={{
                  width: '480px',
                  height: '16px',
                  alignSelf: 'center',
                  borderRadius: '8px',
                  marginTop: 'calc(0.47rem + 1px)',
                  marginBottom: 'calc(0.47rem + 1px)',
                  fontSize: 'inherit',
                  lineHeight: '1.5',
                }}
              />
            </Shimmer>
          )}
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Card>
            <CardBody>
              <div className="float-end">
                <Link to={`/master/scheduler.html`}>
                  <Button outline color="primary">
                    <i className="uil uil-backward"></i> Kembali
                  </Button>
                </Link>
              </div>
              <CardTitle>Detail Scheduler</CardTitle>
              <hr />
              {this.renderDetailRow('Nama Scheduler', this.state.detail?.job_name)}
              {this.renderDetailRow('Waktu', this.state.detail?.job_schedule)}
              {this.renderDetailRow('Query', this.state.detail?.job_query)}
              {this.renderDetailRow('Next Run', this.state.detail?.job_nextrun)}
              {this.renderDetailRow('Status', this.state.detail?.job_status, 'status')}
              {this.renderDetailRow('Run Time Start', this.state.detail?.run_time_start)}
              {this.renderDetailRow('Run Time End', this.state.detail?.run_time_end)}
              {this.renderDetailRow('Message', this.state.detail?.run_message)}
            </CardBody>
          </Card>
        </Container>
      </Fragment>
    );
  }
}

export default IndexView;
